
export function getComponentNameTitleOrPath(component: any): string {
  return component.name?.en
  || (typeof component.name === 'string' && component.name)
  || component.title?.en
  || (typeof component.title === 'string' && component.title)
  || (typeof component.path === 'string' && component.path)
  || '';
}

export function getComponentIdentifier(component: any): string {
  return getComponentNameTitleOrPath(component)
  || component.targetField
  || component.targetPrefix
  // A Templated Block has no name/title/path/targetField, but its `id` is a stable identifier
  // rendered as `data-id` in the editor, so it can serve as a resolvable navigation waypoint.
  // (The AddIdToTemplatedBlock migration guarantees every block on this code path has an id.)
  || (component.kind === 'Templated Block' ? component.id : '')
  // Definition IDs keep saved paths valid after a label change.
  || (component.kind === 'Definition' ? component.id : '')
  || '';
}

// Separates a waypoint's `kind` from its identifier (see `encodeWaypoint`). Shared by every
// consumer that encodes/decodes navigation waypoint strings (ConfigSearch's scroll-to, and
// `collectNavigation`'s stamped `tree` waypoints) so they stay mutually compatible.
export const WAYPOINT_DELIMITER = ': ';

// Marks a waypoint that must be resolved by position (index within its parent's child-list)
// rather than by identifier — used for components the editor renders with no stable identifier,
// namely Conditional Blocks which do not have stable IDs at this time.
export const WAYPOINT_POSITIONAL_PREFIX = '#';

/**
 * Builds a single path waypoint for a component. Uses the component's stable identifier when it has
 * one (rendered as a `data-*` attribute in the editor); otherwise falls back to the component's
 * index within its parent's child-list, encoded with `WAYPOINT_POSITIONAL_PREFIX`.
 */
export function encodeWaypoint(component: any, indexInParent: number): string {
  const identifier = getComponentIdentifier(component);
  if (identifier) return component.kind + WAYPOINT_DELIMITER + identifier;
  return component.kind + WAYPOINT_DELIMITER + WAYPOINT_POSITIONAL_PREFIX + indexInParent;
}
